export default __webpack_public_path__ + "img/1_4-16398afa.png";